<div class="address-book-save-cntr">
  <form [formGroup]="form">

    <mat-form-field>

      <mat-label>Nome</mat-label>

      <input
        matInput
        formControlName="Name" />

      <mat-error *ngIf="form.get('Name')?.hasError('required')"> * Campo obbligatorio</mat-error>

    </mat-form-field>

    <mat-form-field>

      <mat-label>Tipologia</mat-label>
      <mat-select formControlName="Type">
        <mat-option *ngFor="let type of AddressBookType" [value]="type">
          {{ AddressBookTypeLabelMapping[type] }}
        </mat-option>
      </mat-select>

      <mat-error *ngIf="form.get('Type')?.hasError('required')"> * Campo obbligatorio</mat-error>

    </mat-form-field>

    <div
    fxFlex="100" class="m-b-10">
    <mat-checkbox formControlName="Shared">Condividi (rendi disponibile questa rubrica anche agli
      altri membri del tuo
      gruppo)
    </mat-checkbox>
  </div>
  <div
  fxFlex="100">
    <mat-checkbox formControlName="Enabled">Abilitata
    </mat-checkbox>
  </div>

  </form>
</div>